import { render } from "./HikiatekinSettingItem.vue?vue&type=template&id=b4a659e6&ts=true"
import script from "./HikiatekinSettingItem.vue?vue&type=script&lang=ts"
export * from "./HikiatekinSettingItem.vue?vue&type=script&lang=ts"

import "./HikiatekinSettingItem.vue?vue&type=style&index=0&id=b4a659e6&lang=scss"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__